import { AnchoredView } from './AnchoredView';
import { AnchoredSheetProps } from './props';
import { useTitleBar } from './useTitleBar';
import styles from './AnchoredSheet.module.css';

export function AnchoredSheet({
  children,
  onClose,
  title,
  renderTitleBar,
  anchorName,
  align = 'right',
  className,
  initialSize: _initialSize,
  ...rest
}: AnchoredSheetProps) {
  const titleBar = useTitleBar(title, renderTitleBar);
  const alignLeft = align === 'left';

  return (
    <AnchoredView
      anchorName={anchorName}
      onClose={onClose}
      role="dialog"
      aria-modal="true"
      className={[styles.anchoredSheet, alignLeft && styles.alignLeft, className]}
      {...rest}
    >
      {titleBar}
      {children}
    </AnchoredView>
  );
}
